export default __webpack_public_path__ + "static/media/brands_logo.3e5a6a28.svg";